const firebaseConfig = {
  apiKey: "AIzaSyD5noJseBGWOyucBGDI-VBYJqQBihZBXas",
  authDomain: "apollo-health-care.firebaseapp.com",
  projectId: "apollo-health-care",
  storageBucket: "apollo-health-care.appspot.com",
  messagingSenderId: "162827514265",
  appId: "1:162827514265:web:5f47e0b10508301deee308",
  measurementId: "G-WNN4MP45GS",
};
export default firebaseConfig;
